module.exports = __webpack_public_path__ + "static/media/notification-svgrepo-com (1).fa937eb4.svg";